import { Button, Modal, Textarea } from 'flowbite-react';
import React, { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';
import ClosePositionOptionElement from './ClosePositionOptionElement';
import { useMutation, useQueryClient } from 'react-query';
import { closePosition } from 'src/apis/position';
import { Loader } from 'ui';
import { useToast } from 'src/context/ToastProvider';
import { get } from 'lodash';

const closePositonOptions = [
	{
		label: 'Position filled on LevelUp',
	},
	{
		label: 'Position filled elsewhere',
	},
	{
		label: 'Recommendations not appropriate',
	},
	{
		label: 'Hiring Freeze',
	},
	{
		label: 'Other',
	},
];

interface Props {
	isOpen: boolean;
	positionId: string;
	onClose: () => void;
}

const CloseRecruiterPositionModal = ({ isOpen, positionId, onClose }: Props) => {
	const queryClient = useQueryClient();
	const toast = useToast();
	const [selectedOption, setSelectedOption] = useState<string>('');
	const [otherText, setOtherText] = useState<string>('');

	const disableConfirm = selectedOption === 'Other' ? !otherText : !selectedOption;

	const closePositionFn = useMutation(['closePosition'], closePosition, {
		onSuccess(data) {
			toast({
				title: 'Position Closed Successfully',
				duration: 3000,
				type: 'success',
			});
			queryClient.refetchQueries(['getMyRegisteredPositions']);
			onClose();
		},
		onError(error: Error) {
			const errorMessage = get(error, ['response', 'data', 'message'], error.message);
			toast({
				type: 'error',
				title: errorMessage,
			});
		},
	});

	const handleSelect = (option: string) => {
		setSelectedOption(option);
	};

	const handleConfirm = () => {
		// close position mutation
		closePositionFn.mutate({ id: positionId, payload: selectedOption });
	};

	return (
		<Modal size="md" show={isOpen} onClose={onClose} dismissible>
			<Modal.Body className="relative rounded-[8px] border border-solid dark:border-[#4B5563] bg-white dark:bg-[#1F2A37]">
				<div className="text-[16px] font-[500] dark:text-[#F2F2F5] text-center">Please select one of the reasons.</div>

				<div className="flex flex-col gap-3 mt-4">
					{closePositonOptions.map(o => (
						<ClosePositionOptionElement
							key={o.label}
							handleSelect={handleSelect}
							isSelected={o.label === selectedOption}
							label={o.label}
						/>
					))}

					{selectedOption === 'Other' ? (
						<Textarea
							placeholder="Write your reasons here..."
							value={otherText}
							onChange={e => setOtherText(e.target.value)}
							className="dark:bg-[#4B5563] dark:text-[#C7C9D9]"
						/>
					) : null}
				</div>

				<div className="flex justify-center mt-4">
					<Button onClick={handleConfirm} color="purplePlaced" disabled={disableConfirm || closePositionFn.isLoading}>
						{closePositionFn.isLoading ? <Loader /> : 'Confirm'}
					</Button>
				</div>

				<RxCross2
					onClick={onClose}
					className="absolute right-[16px] top-[16px] h-[20px] w-[20px] cursor-pointer text-[#9CA3AF]"
				/>
			</Modal.Body>
		</Modal>
	);
};

export default CloseRecruiterPositionModal;
